webpackJsonp([21],{

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_legal_vue__ = __webpack_require__(719);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25d30a93_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_legal_vue__ = __webpack_require__(810);
function injectStyle (ssrContext) {
  __webpack_require__(804)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25d30a93"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_legal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25d30a93_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_legal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: {
    short: 'BEC',
    long: 'INSTALACIONES BEC'
  }
});

/***/ }),

/***/ 719:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vuetify_fullscreen_dialog__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app__ = __webpack_require__(680);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VuetifyFullscreenDialog: __WEBPACK_IMPORTED_MODULE_0__components_vuetify_fullscreen_dialog__["a" /* default */]
  },
  data: function data() {
    return {
      route: null,
      name: __WEBPACK_IMPORTED_MODULE_1__config_app__["a" /* default */].name.long,
      title: null
    };
  },
  mounted: function mounted() {
    this.route = this.$route.name;
    if (this.route === 'privacy-policy') {
      this.title = 'POLÍTICA DE PRIVACIDAD';
    } else if (this.route === 'cookies-policy') {
      this.title = 'POLÍTICA DE COOKIES';
    } else if (this.route === 'legal-advice') {
      this.title = 'AVISO LEGAL';
    }
  },


  methods: {

    /**
     * Check if it is a login page.
     *
     * @return {Boolean}
     */
    onClose: function onClose() {}
  }
});

/***/ }),

/***/ 720:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuetify-fullscreen-dialog',

  props: {
    title: {
      type: String,
      default: 'Settings'
    },
    textButton: {
      type: String,
      default: 'Close'
    },
    dialog: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: true
    },
    flat: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'primary'
    },
    overlay: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      show: this.dialog
    };
  },


  methods: {
    /**
     * Get custom parameters or use the default parameters.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onClose: function onClose() {
      this.$router.go(-1);
    }
  }
});

/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(805);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("6d39e4dc", content, true, {});

/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".headline[data-v-25d30a93]{font-size:31px!important;font-weight:bolder}.section[data-v-25d30a93]{margin-top:-25px;font-weight:500;font-size:21px;margin-bottom:-5px}.avatar[data-v-25d30a93]{margin-top:1px;border:2px solid #fff;background-color:#2b3036}.flex[data-v-25d30a93]{width:100%}.card[data-v-25d30a93]{max-width:800px;margin:0 auto;color:#fff}.divider[data-v-25d30a93]{background-color:hsla(0,0%,100%,.12)!important;max-width:600px}.mb-0[data-v-25d30a93]{padding:20px 0}table[data-v-25d30a93]{font-family:arial,sans-serif;border-collapse:collapse;width:100%;margin-top:20px;margin-bottom:20px}td[data-v-25d30a93],th[data-v-25d30a93]{border:1px solid #ddd;text-align:left;padding:8px}tr[data-v-25d30a93]:nth-child(2n){background-color:#1b2024}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/pages/legal.vue"],"names":[],"mappings":"AACA,2BACE,yBAA2B,AAC3B,kBAAoB,CACrB,AACD,0BACE,iBAAkB,AAClB,gBAAiB,AACjB,eAAgB,AAChB,kBAAoB,CACrB,AACD,yBACE,eAAgB,AAChB,sBAA0B,AAC1B,wBAA0B,CAC3B,AACD,uBACE,UAAY,CACb,AACD,uBACE,gBAAiB,AACjB,cAAe,AACf,UAAa,CACd,AACD,0BACE,+CAAuD,AACvD,eAAiB,CAClB,AACD,uBACE,cAAkB,CACnB,AACD,uBACE,6BAA+B,AAC/B,yBAA0B,AAC1B,WAAY,AACZ,gBAAiB,AACjB,kBAAoB,CACrB,AACD,wCACE,sBAA0B,AAC1B,gBAAiB,AACjB,WAAa,CACd,AACD,kCACE,wBAA0B,CAC3B","file":"legal.vue","sourcesContent":["\n.headline[data-v-25d30a93] {\n  font-size: 31px !important;\n  font-weight: bolder;\n}\n.section[data-v-25d30a93] {\n  margin-top: -25px;\n  font-weight: 500;\n  font-size: 21px;\n  margin-bottom: -5px;\n}\n.avatar[data-v-25d30a93] {\n  margin-top: 1px;\n  border: 2px solid #ffffff;\n  background-color: #2b3036;\n}\n.flex[data-v-25d30a93] {\n  width: 100%;\n}\n.card[data-v-25d30a93] {\n  max-width: 800px;\n  margin: 0 auto;\n  color: white;\n}\n.divider[data-v-25d30a93] {\n  background-color: rgba(255, 255, 255, 0.12) !important;\n  max-width: 600px;\n}\n.mb-0[data-v-25d30a93] {\n  padding: 20px 0px;\n}\ntable[data-v-25d30a93] {\n  font-family: arial, sans-serif;\n  border-collapse: collapse;\n  width: 100%;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\ntd[data-v-25d30a93], th[data-v-25d30a93] {\n  border: 1px solid #dddddd;\n  text-align: left;\n  padding: 8px;\n}\ntr[data-v-25d30a93]:nth-child(even) {\n  background-color: #1b2024;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 806:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_fullscreen_dialog_vue__ = __webpack_require__(720);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_252a61c5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_fullscreen_dialog_vue__ = __webpack_require__(809);
function injectStyle (ssrContext) {
  __webpack_require__(807)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_fullscreen_dialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_252a61c5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_fullscreen_dialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(808);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("3a696daf", content, true, {});

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, "html{overflow-y:auto}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-fullscreen-dialog.vue"],"names":[],"mappings":"AACA,KACE,eAAiB,CAClB","file":"vuetify-fullscreen-dialog.vue","sourcesContent":["\nhtml {\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 809:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition","overlay":_vm.overlay},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":_vm.dark,"color":_vm.color}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.onClose()}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":_vm.dark,"flat":_vm.flat},nativeOn:{"click":function($event){_vm.onClose()}}},[_vm._v(_vm._s(_vm.textButton))])],1)],1),_vm._v(" "),_vm._t("content")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 810:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-fullscreen-dialog',{attrs:{"title":_vm.title,"textButton":'entendido',"dialog":true}},[_c('template',{slot:"content"},[_c('v-layout',{attrs:{"column":""}},[_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md8":"","text-xs-center":"","layout":"","align-center":"","justify-center":""}},[_c('v-avatar',{attrs:{"slot":"activator","size":"125px"},slot:"activator"},[_c('img',{attrs:{"src":"/static/images/login/logo.png","alt":""}})])],1)],1),_vm._v(" "),_c('div',{staticClass:"headline white--text text-xs-center pa-5"},[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")]),_vm._v(" "),_c('span',{staticClass:"section text-xs-center primary--text"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n      ")]),_vm._v(" "),_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('br'),_c('br'),_c('v-divider',{attrs:{"light":""}}),_c('br'),_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{attrs:{"flat":"","dark":""}},[(this.route === 'privacy-policy')?_c('v-card-title',{attrs:{"primary-title":""}},[_c('h2',{staticClass:"mb-0"},[_vm._v("1. DATOS DEL RESPONSABLE DEL TRATAMIENTO")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Razón Social: INSTALACIONES BEC CLIMATIZACION SOCIEDAD LIMITADA (en adelante, la “Empresa” o el “Responsable”)."),_c('br'),_vm._v("\n              CIF: B67028431"),_c('br'),_vm._v("\n              Domicilio: Calle Iglesia, N°: 85, Sobreático 2 - 08860 - Castelldefels - BARCELONA"),_c('br'),_vm._v("\n              Teléfono: 654299468"),_c('br'),_vm._v("\n              Email para comunicaciones en materia de Protección de datos: instalacionesbec@gmail.com")]),_c('br'),_vm._v(" "),_c('h3',{staticClass:"mb-0"},[_vm._v("1.1. Normativa aplicable")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Nuestra Política de Privacidad se ha diseñado de acuerdo con el Reglamento General de Protección de Datos de la UE 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (Reglamento general de protección de datos), y en lo que no contradiga el mencionado Reglamento, por lo dispuesto en el marco legislativo español en materia de Protección de Datos de Carácter Personal."),_c('br'),_c('br'),_vm._v("\n              Al facilitarnos sus datos, Usted declara haber leído y conocer la presente Política de Privacidad, prestando su consentimiento inequívoco y expreso al tratamiento de sus datos personales de acuerdo a las finalidades y términos aquí expresados. La Empresa podrá modificar la presente Política de Privacidad para adaptarla a las novedades legislativas, jurisprudenciales o de interpretación de la Agencia Española de Protección de Datos."),_c('br'),_c('br'),_vm._v("\n              Estas condiciones de privacidad podrán ser complementadas por el Aviso Legal, Política de Cookies y las Condiciones Generales que, en su caso, se recojan para determinados productos o servicios, si dicho acceso supone alguna especialidad en materia de protección de datos de carácter personal.")]),_vm._v(" "),_c('h3',{staticClass:"mb-0"},[_vm._v("1.2. Delegado de Protección de Datos")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("La empresa no tiene Delegado de Protección de Datos.")]),_vm._v(" "),_c('h2',{staticClass:"mb-0"},[_vm._v("2. FINALIDAD DEL TRATAMIENTO DE LOS DATOS PERSONALES")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("El tratamiento que realizamos de sus datos personales responde a las siguientes finalidades:"),_c('br'),_c('br')]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("- Proporcionarle información relacionada con los productos y servicios que ofrece nuestra empresa y que detallan en este web site.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("- Realizar la contratación de nuestros servicios mediante la aceptación del correspondiente presupuesto / pedido y/o la firma de un contrato mercantil.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("- Enviarle por correo electrónico y/o postal las noticias y novedades acerca de nuestra entidad, así como las actualizaciones de nuestro catálogo de productos y servicios.")]),_vm._v(" "),_c('h3',{staticClass:"mb-0"},[_vm._v("2.1. Plazo de Conservación de sus datos")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Conservaremos sus datos personales desde que nos dé su consentimiento hasta que lo revoque o bien solicite la limitación del tratamiento. En tales casos, mantendremos sus datos de manera bloqueada durante los plazos legalmente exigidos.")]),_vm._v(" "),_c('h2',{staticClass:"mb-0"},[_vm._v("3. LEGITIMACIÓN Y DATOS RECABADOS")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("La legitimación para el tratamiento de sus datos es el consentimiento expreso otorgado mediante un acto positivo y afirmativo (rellenar el formulario correspondiente y marcar la casilla de aceptación de esta política) en el momento de facilitarnos sus datos personales.")]),_c('br'),_vm._v(" "),_c('h3',{staticClass:"mb-0"},[_vm._v("3.1. Consentimiento para tratar sus datos")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Al rellenar los formularios, marcar la casilla “Acepto la Política de Privacidad” y hacer clic para enviar los datos, o al remitir correos electrónicos a la Empresa a través de las cuentas habilitadas al efecto, el Usuario manifiesta haber leído y aceptado expresamente la presente política de privacidad, y otorga su consentimiento inequívoco y expreso al tratamiento de sus datos personales conforme a las finalidades indicadas.")]),_c('br'),_vm._v(" "),_c('h3',{staticClass:"mb-0"},[_vm._v("3.2. Categorías de datos")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Los datos que se recaban se refieren a la categoría de datos identificativos, como pueden ser: Nombre y Apellidos, Teléfono, Dirección Postal, Empresa, Correo electrónico, así como la dirección IP desde donde accede al formulario de recogida de datos.")]),_c('br'),_vm._v(" "),_c('h2',{staticClass:"mb-0"},[_vm._v("4. MEDIDAS DE SEGURIDAD")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Dentro de nuestro compromiso por garantizar la seguridad y confidencialidad de sus datos de carácter personal, le informamos que se han adoptado las medidas de índole técnica y organizativas necesarias para garantizar la seguridad de los datos de carácter personal y evitar su alteración, pérdida, tratamiento o acceso no autorizado, habida cuenta del estado de la tecnología, la naturaleza de los datos almacenados y los riesgos a que estén expuestos, según el Art. 32 del RGPD EU 679/2016.")]),_c('br'),_vm._v(" "),_c('h2',{staticClass:"mb-0"},[_vm._v("5. CESIÓN DE DATOS")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("No se prevén cesiones de datos ni transferencias internacionales de sus datos, a excepción de las autorizadas por la legislación fiscal, mercantil y de telecomunicaciones así como en aquellos casos en los que una autoridad judicial nos lo requiera.")]),_c('br'),_vm._v(" "),_c('h2',{staticClass:"mb-0"},[_vm._v("6. DERECHOS DEL USUARIO")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Cualquier interesado tiene derecho a obtener confirmación sobre si estamos tratando datos personales que le conciernan, o no. Las personas interesadas tienen derecho a acceder a sus datos personales, así como a solicitar la rectificación de los datos inexactos o, en su caso, solicitar su supresión cuando, entre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos. En determinadas circunstancias, los interesados podrán solicitar la limitación del tratamiento de sus datos, en cuyo caso únicamente los conservaremos para el ejercicio o la defensa de reclamaciones. Por motivos relacionados con su situación particular, los interesados podrán oponerse oponerse al tratamiento de sus datos. El Responsable del fichero dejará de tratar los datos, salvo por motivos legítimos imperiosos, o el ejercicio o la defensa de posibles reclamaciones."),_c('br'),_c('br'),_vm._v("\n              De acuerdo con la legislación vigente tiene los siguientes derechos: derecho a solicitar el acceso a sus datos personales, derecho a solicitar su rectificación o supresión, derecho a solicitar la limitación de su tratamiento, derecho a oponerse al tratamiento, derecho a la portabilidad de los datos y así mismo, a revocar el consentimiento otorgado.")]),_c('br'),_vm._v(" "),_c('h3',{staticClass:"mb-0"},[_vm._v("6.1. ¿Cómo ejercitar mis derechos?")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Para ejercer sus derechos, debe dirigirse al responsable, solicitando el correspondiente formulario para el ejercicio del derecho elegido. Opcionalmente, puede acudir a la Autoridad de Control competente para obtener información adicional acerca de sus derechos. Los datos de contacto para el ejercicio de sus derechos son el teléfono 654299468 y el correo electrónico: instalacionesbec@gmail.com. Recuerde acompañar una copia de un documento que nos permita identificarle.")]),_c('br'),_vm._v(" "),_c('h2',{staticClass:"mb-0"},[_vm._v("7. CONSENTIMIENTO PARA ENVÍO DE COMUNICACIONES ELECTRÓNICAS")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Así mismo, y de acuerdo con lo establecido en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, completando el formulario de recogida de datos y marcando la correspondiente casilla “Acepto el envío de comunicaciones electrónicas”, esta otorgando el consentimiento expreso para enviarle a su dirección de correo electrónico, teléfono, fax u otro medio electrónico en envío de información acerca de la Empresa.")]),_c('br')]):_vm._e(),_vm._v(" "),(this.route === 'legal-advice')?_c('v-card-title',{attrs:{"primary-title":""}},[_c('span',{staticClass:"white--text"},[_vm._v("Con la finalidad de dar cumplimiento al artículo 10 de la Ley 34/2002 de Servicios de la Sociedad de la Información y Comercio Electrónico, informamos al usuario de nuestros datos:")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Denominación Social: INSTALACIONES BEC CLIMATIZACION SOCIEDAD LIMITADA"),_c('br'),_vm._v("\n              Nombre Comercial:"),_c('br'),_vm._v("\n              Domicilio Social: Calle Iglesia, N°: 85, Sobreático 2 - 08860 - Castelldefels - BARCELONA"),_c('br'),_vm._v("\n              CIF / NIF: B67028431"),_c('br'),_vm._v("\n              Teléfono: 654299468"),_c('br'),_vm._v("\n              Fax:"),_c('br'),_vm._v("\n              e-Mail: instalacionesbec@gmail.com"),_c('br'),_vm._v("\n              Datos registrales:"),_c('br'),_vm._v("\n              Pagina Web: WWW.INSTALACIONESBEC.COM //\n              WWW.INSTALACIONESBEC.NET//WWW.INSTALACIONESBEC.ES//WWW.INSTALACIONESBEC.ORG\n              //WWW.INSTALACIONESBEC.INFO//WWW.AIREINSTALADO.COM//WWW.GESTIONIBEC.COM")]),_vm._v(" "),_c('h3',{staticClass:"mb-0"},[_vm._v("Objeto")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("El prestador, responsable del sitio web, pone a disposición de los usuarios el presente documento con el que pretende dar cumplimiento a las obligaciones dispuestas en la Ley 34/2002, de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSI-CE), así como informar a todos los usuarios del sitio web respecto a cuáles son las condiciones de uso del sitio web.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Toda persona que acceda a este sitio web asume el papel de usuario, comprometiéndose a la observancia y cumplimiento riguroso de las disposiciones aquí dispuestas, así como a cualquier otra disposición legal que fuera de aplicación.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("El prestador se reserva el derecho a modificar cualquier tipo de información que pudiera aparecer en el sitio web, sin que exista obligación de preavisar o poner en conocimiento de los usuarios dichas obligaciones, entendiéndose como suficiente con la publicación en el sitio web del prestador.")]),_vm._v(" "),_c('h3',{staticClass:"mb-0"},[_vm._v("Responsabilidad")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("El prestador se exime de cualquier tipo de responsabilidad derivada de la información publicada en su sitio web, siempre que esta información haya sido manipulada o introducida por un tercero ajeno al mismo.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("El sitio web del prestador puede utilizar cookies (pequeños archivos de información que el servidor envía al ordenador de quien accede a la página) para llevar a cabo determinadas funciones que son consideradas imprescindibles para el correcto funcionamiento y visualización del sitio. Las cookies utilizadas en el sitio web tienen, en todo caso, carácter temporal con la única finalidad de hacer más eficaz su transmisión ulterior y desaparecen al terminar la sesión del usuario. En ningún caso se utilizarán las cookies para recoger información de carácter personal.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Desde el sitio web del cliente es posible que se redirija a contenidos de terceros sitios web. Dado que el prestador no puede controlar siempre los contenidos introducidos por los terceros en sus sitios web, éste no asume ningún tipo de responsabilidad respecto a dichos contenidos. En todo caso, el prestador manifiesta que procederá a la retirada inmediata de cualquier contenido que pudiera contravenir la legislación nacional o internacional, la moral o el orden público, procediendo a la retirada inmediata de la redirección a dicho sitio web, poniendo en conocimiento de las autoridades competentes el contenido en cuestión.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("El prestador no se hace responsable de la información y contenidos almacenados, a título enunciativo pero no limitativo, en foros, chats, generadores de blogs, comentarios, redes sociales o cualquier otro medio que permita a terceros publicar contenidos de forma independiente en la página web del prestador.")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("No obstante y en cumplimiento de lo dispuesto en el art. 11 y 16 de la LSSI-CE, el prestador se pone a disposición de todos los usuarios, autoridades y fuerzas de seguridad, y colaborando de forma activa en la retirada o en su caso bloqueo de todos aquellos contenidos que pudieran afectar o contravenir la legislación nacional, o internacional, derechos de terceros o la moral y el orden público. En caso de que el usuario considere que existe en el sitio web algún contenido que pudiera ser susceptible de esta clasificación, se ruega lo notifique de forma inmediata al administrador del sitio web.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Este sitio web ha sido revisado y probado para que funcione correctamente. En principio, puede garantizarse el correcto funcionamiento los 365 días del año, 24 horas al día. No obstante, el prestador no descarta la posibilidad de que existan ciertos errores de programación, o que acontezcan causas de fuerza mayor, catástrofes naturales, huelgas, o circunstancias semejantes que hagan imposible el acceso a la página web.")]),_vm._v(" "),_c('h3',{staticClass:"mb-0"},[_vm._v("Propiedad Intelectual e industrial")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("El sitio web, incluyendo a título enunciativo pero no limitativo su programación, edición, compilación y demás elementos necesarios para su funcionamiento, los diseños, logotipos, texto y/o gráficos son propiedad del prestador o en su caso dispone de licencia o autorización expresa por parte de los autores. Todos los contenidos del sitio web se encuentran debidamente protegidos por la normativa de propiedad intelectual e industrial, así como inscritos en los registros públicos correspondientes.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Independientemente de la finalidad para la que fueran destinados, la reproducción total o parcial, uso, explotación, distribución y comercialización, requiere en todo caso de la autorización escrita previa por parte del prestador. Cualquier uso no autorizado previamente por parte del prestador será considerado un incumplimiento grave de los derechos de propiedad intelectual o industrial del autor.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Los diseños, logotipos, texto y/o gráficos ajenos al prestador y que pudieran aparecer en el sitio web, pertenecen a sus respectivos propietarios, siendo ellos mismos responsables de cualquier posible controversia que pudiera suscitarse respecto a los mismos. En todo caso, el prestador cuenta con la autorización expresa y previa por parte de los mismos.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("El prestador NO AUTORIZA expresamente a que terceros puedan redirigir directamente a los contenidos concretos del sitio web, debiendo en todo caso redirigir al sitio web principal del prestador.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("El prestador reconoce a favor de sus titulares los correspondientes derechos de propiedad industrial e intelectual, no implicando su sola mención o aparición en el sitio web la existencia de derechos o responsabilidad alguna del prestador sobre los mismos, como tampoco respaldo, patrocinio o recomendación por parte del mismo.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Para realizar cualquier tipo de observación respecto a posibles incumplimientos de los derechos de propiedad intelectual o industrial, así como sobre cualquiera de los contenidos del sitio web, puede hacerlo a través del siguiente correo electrónico.")]),_vm._v(" "),_c('h3',{staticClass:"mb-0"},[_vm._v("Veracidad de la información.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Toda la información que facilita el Usuario tiene que ser veraz. A estos efectos, el Usuario garantiza la autenticidad de los datos comunicados a través de los formularios para la suscripción de los Servicios. Será responsabilidad del Usuario mantener toda la información facilitada a INSTALACIONES BEC CLIMATIZACION SOCIEDAD LIMITADA permanentemente actualizada de forma que responda, en cada momento, a su situación real. En todo caso, el Usuario será el único responsable de las manifestaciones falsas o inexactas que realice y de los perjuicios que cause al prestador o a terceros.")]),_vm._v(" "),_c('h3',{staticClass:"mb-0"},[_vm._v("Menores de edad.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Para el uso de los servicios, los menores de edad tienen que obtener siempre previamente el consentimiento de los padres, tutores o representantes legales, responsables últimos de todos los actos realizados por los menores a su cargo. La responsabilidad en la determinación de contenidos concretos a los cuales acceden los menores corresponde a aquellos, es por eso que si acceden a contenidos no apropiados por Internet, se tendrán que establecer en sus ordenadores mecanismos, en particular programas informáticos, filtros y bloqueos, que permitan limitar los contenidos disponibles y, a pesar de que no sean infalibles, son de especial utilidad para controlar y restringir los materiales a los que pueden acceder los menores.")]),_vm._v(" "),_c('h3',{staticClass:"mb-0"},[_vm._v("Obligación de hacer un uso correcto de la Web.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("El Usuario se compromete a utilizar la Web de conformidad a la Ley y al presente Aviso Legal, así como a la moral y a buenas costumbres. A tal efecto, el Usuario se abstendrá de utilizar la página con finalidades ilícitas o prohibidas, lesivas de derechos e intereses de terceros, o que de cualquier forma puedan dañar, inutilizar, sobrecargar, deteriorar o impedir la normal utilización de equipos informáticos o documentos, archivos y toda clase de contenidos almacenados en cualquier equipo informático del prestador.")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("En particular, y a título indicativo pero no exhaustivo, el Usuario se compromete a no transmitir, difundir o poner a disposición de terceros informaciones, datos, contenidos, mensajes, gráficos, dibujos, archivos de sonido o imagen, fotografías, grabaciones, software y, en general, cualquier clase de material que:")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("(a) sea contraria, desprecie o atente contra los derechos fundamentales y las libertades públicas reconocidas constitucionalmente, en tratados internacionales y otras normas vigentes;")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("(b) induzca, incite o promueva actuaciones delictivas, denigrantes,")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("(c) induzca, incite o promueva actuaciones, actitudes o pensamientos discriminatorios por razón de sexo, raza, religión, creencias, edad o condición;")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("(d) sea contrario al derecho al honor, a la intimidad personal o familiar o a la propia imagen de las personas;")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("(e) de cualquier manera perjudique la credibilidad del prestador o de terceros; y")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("(f) constituya publicidad ilícita, engañosa o desleal.")]),_vm._v(" "),_c('h3',{staticClass:"mb-0"},[_vm._v("Ley Aplicable y Jurisdicción")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Para la resolución de todas las controversias o cuestiones relacionadas con el presente sitio web o de las actividades en él desarrolladas, será de aplicación la legislación española, a la que se someten expresamente las partes, siendo competentes para la resolución de todos los conflictos derivados o relacionados con su uso los Juzgados y Tribunales de Castelldefels.")])]):(this.route === 'cookies-policy')?_c('v-card-title',{attrs:{"primary-title":""}},[_c('h2',{staticClass:"mb-0"},[_vm._v("1.- ANTECEDENTES")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("De conformidad con la normativa española que regula el uso de cookies en relación a la prestación de servicios de comunicaciones electrónicas, recogida en el Real Decreto Ley 13/2012 del 30 de marzo, le informamos sobre las cookies utilizadas en el sitio web de (nombre de la empresa) y el motivo de su uso. Asimismo, le informa de que al navegar en el Sitio Web usted está prestando su consentimiento para poder utilizarlas.")]),_vm._v(" "),_c('h2',{staticClass:"mb-0"},[_vm._v("2.- ¿QUE SON LAS COOKIES?")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Una cookie es un fichero que se descarga en su ordenador al acceder a determinadas páginas web. Las cookies permiten a una página web, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario. Las cookies se asocian únicamente a un usuario anónimo y su ordenador o dispositivo y no proporcionan referencias que permitan conocer sus datos personales. ")]),_vm._v(" "),_c('h2',{staticClass:"mb-0"},[_vm._v("3.- TIPOS DE COOKIES")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("1.- Cookies propias: Son aquéllas que se envían al equipo terminal del usuario desde un equipo o dominio gestionado por el propio editor y desde el que se presta el servicio Solicitado por el usuario.")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("2.- Cookies de terceros: Son aquéllas que se envían al equipo terminal del usuario desde un equipo o dominio que no es gestionado por el editor, sino por otra entidad que trata los datos obtenidos través de las cookies.")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("3.- Cookies de sesión: Son un tipo de cookies diseñadas para recabar y almacenar datos mientras el usuario accede a una página web.")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("4.- Cookies persistentes: Son un tipo de cookies en el que los datos siguen almacenados en el terminal y pueden ser accedidos y tratados durante un periodo definido por el responsable de la cookie, y que puede ir de unos minutos a varios años. ")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("5.- Cookies de análisis: Son aquéllas que bien tratadas por nosotros o por terceros, nos permiten cuantificar el número de usuarios y así realizar la medición y análisis estadístico de la utilización que hacen los usuarios del servicio ofertado. Para ello se analiza su navegación en nuestra página web con el fin de mejorar la oferta de productos o servicios que le ofrecemos.")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("6.- Cookies publicitarias: Son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado en base a criterios como el contenido editado o la frecuencia en la que se muestran los anuncios.")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("7.- Cookies de publicidad comportamental: Son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado. Estas cookies almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función del mismo. Asimismo es posible que al visitar alguna página web o al abrir algún email donde se publique algún anuncio o alguna promoción sobre nuestros productos o servicios se instale en tu navegador alguna cookie que nos sirve para mostrarte posteriormente publicidad relacionada con la búsqueda que hayas realizado, desarrollar un control de nuestros anuncios en relación, por ejemplo, con el número de veces que son vistos, donde aparecen, a qué hora se ven, etc.")]),_c('br'),_vm._v(" "),_c('h2',{staticClass:"mb-0"},[_vm._v("4.- TIPOS DE COOKIES UTILIZADAS POR ESTE SITIO WEB")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Las cookies utilizadas en nuestro sitio web, son de sesión y de terceros, y nos permiten almacenar y acceder a información relativa al idioma, el tipo de navegador utilizado, y otras características generales predefinidas por el usuario, así como, seguir y analizar la actividad que lleva a cabo, con el objeto de introducir mejoras y prestar nuestros servicios de una manera más eficiente y personalizada. INSTALACIONES BEC no utiliza cookies publicitarias o de publicidad comportamental.")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("La utilización de las cookies ofrece ventajas en la prestación de servicios dentro de lo que se conoce como la sociedad de la información, puesto que, facilita al usuario la navegación y el acceso a los diferentes servicios que ofrece este sitio web; evita al usuario tener que configurar las características generales predefinidas cada vez que accede al sitio web; favorece la mejora del funcionamiento y de los servicios prestados a través de este sitio web, tras el correspondiente análisis de la información obtenida a través de las cookies instaladas.")]),_c('br'),_vm._v(" "),_c('table',[_c('tr',[_c('th',[_vm._v("Nombre")]),_vm._v(" "),_c('th',[_vm._v("Tipo")]),_vm._v(" "),_c('th',[_vm._v("Caducidad")]),_vm._v(" "),_c('th',[_vm._v("Finalidad")]),_vm._v(" "),_c('th',[_vm._v("Clase")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("accessToken")]),_vm._v(" "),_c('td',[_vm._v("Propia")]),_vm._v(" "),_c('td',[_vm._v("Indefinida hasta eliminar cookies.")]),_vm._v(" "),_c('td',[_vm._v("Se usa para distinguir usuarios y sesiones.")]),_vm._v(" "),_c('td',[_vm._v("No exenta")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("refreshToken")]),_vm._v(" "),_c('td',[_vm._v("Propia")]),_vm._v(" "),_c('td',[_vm._v("Indefinida hasta eliminar cookies.")]),_vm._v(" "),_c('td',[_vm._v("Se usa para distinguir usuarios y sesiones.")]),_vm._v(" "),_c('td',[_vm._v("No exenta")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("expiresIn")]),_vm._v(" "),_c('td',[_vm._v("Propia")]),_vm._v(" "),_c('td',[_vm._v("Indefinida hasta eliminar cookies.")]),_vm._v(" "),_c('td',[_vm._v("Se usa para determinar la duración válida de los tokens anteriores.")]),_vm._v(" "),_c('td',[_vm._v("No exenta")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("uuid")]),_vm._v(" "),_c('td',[_vm._v("Propia")]),_vm._v(" "),_c('td',[_vm._v("Indefinida hasta eliminar cookies.")]),_vm._v(" "),_c('td',[_vm._v("Se usa para distinguir usuarios y sesiones.")]),_vm._v(" "),_c('td',[_vm._v("No exenta")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("rolID")]),_vm._v(" "),_c('td',[_vm._v("Propia")]),_vm._v(" "),_c('td',[_vm._v("Indefinida hasta eliminar cookies.")]),_vm._v(" "),_c('td',[_vm._v("Se usa para distinguir usuarios y sesiones.")]),_vm._v(" "),_c('td',[_vm._v("No exenta")])])]),_vm._v(" "),_c('h2',{staticClass:"mb-0"},[_vm._v("5.- REVOCACIÓN Y ELIMINACIÓN DE COOKIES")]),_vm._v(" "),_c('div',[_c('span',{staticClass:"white--text"},[_vm._v("En todo momento podrá acceder a la configuración de su navegador aceptando o rechazando todas las cookies, o bien seleccionar aquéllas cuya instalación admite y cuáles no, siguiendo uno de los siguientes procedimientos, que depende del navegador que utilice:")]),_c('br'),_c('br'),_vm._v(" "),_c('span',[_c('a',{attrs:{"href":"https://support.google.com/chrome/answer/95647?hl=es"}},[_vm._v("Google Chrome")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://windows.microsoft.com/es-es/windows7/how-to-manage-cookies-in-internet-explorer-9"}},[_vm._v("Internet Explorer")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we"}},[_vm._v("Mozilla Firefox")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"http://support.apple.com/kb/ph5042"}},[_vm._v("Safari")])])]),_vm._v(" "),_c('h2',{staticClass:"mb-0"},[_vm._v("6.- TERCEROS PRESTADORES DE SERVICIOS")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("No se utilizan cookies de prestadores de servicios de terceros.")]),_c('br'),_c('br')]):_vm._e()],1)],1)],1)],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/21.e4386275384aaa917a4e.js